import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
} from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { Home, HomeLoader } from './ui/home/page';
import { Project, ProjectLoader } from './ui/project/page';
import DefaultErrorPage from './ui/error/default';
import Root from './ui/root';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={<Root />}
    >
      <Route errorElement={<DefaultErrorPage />}>
        <Route index element={<Home />} loader={HomeLoader} />
        <Route
          path="/project/:projectId"
          element={<Project />}
          loader={ProjectLoader}
        />
      </Route>
    </Route>,
  ),
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
